"use client";
import { Box, Flex } from "@radix-ui/themes";
import React from "react";
import ListDetails from "../components/ListDetails";
import { Separator } from "../components/ui/separator";
import { format } from "date-fns";

interface Props {
  startDate: Date;
  endDate: Date;
}
const BuyerHomeAuctionDetails = ({ startDate, endDate }: Props) => {
  return (
    <Flex
      justify={"center"}
      className={"w-full flex-col items-center lg:flex-row lg:items-start"}
    >
      <ListDetails
        startDate={startDate}
        endDate={endDate}
      />
    </Flex>
  );
};

export default BuyerHomeAuctionDetails;
